import RouteRedirect from './RouteRedirect';
export default RouteRedirect;
